<template>
  <div class="label-answers t-text t-bold u-shadow" :class="{'is-true': state === 1, 'is-false': state === 2}">
    {{ text }}
  </div>
</template>

<script>
export default {
  props: {
    state: {
      type: Number,
      default: 0 // 0 -> base, 1 -> true, 2 -> false
    },
    position: {
      type: Object,
      default: () => {}
    },
    text: {
      type: String,
      default: ''
    }
  },

  methods: {
    onUpdate () {
      this.$el.style.transform = `translate(calc( ${this.position.x}px - 50%), ${this.position.y + 20}px)`
    }
  }
}  
</script>

<style lang="stylus">
@import '~@/styles/settings/variables'

.label-answers
  border solid 2px $colors.white
  padding 5px 30px 7px
  border-radius 30px
  overflow hidden
  position absolute
  top 0
  left 0
  z-index 1
  
  &:before, &:after
    content ''
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    z-index -1
    transition opacity .3s
    opacity 0
    background-color: $colors.green
  
  &:after
    background-color: $colors.red
  
  &.is-true:before
    opacity 1
  
  &.is-false:after
    opacity 1

</style>